import { render, staticRenderFns } from "./singleChoose.vue?vue&type=template&id=a9be0534&scoped=true&"
import script from "./singleChoose.vue?vue&type=script&lang=js&"
export * from "./singleChoose.vue?vue&type=script&lang=js&"
import style0 from "./singleChoose.vue?vue&type=style&index=0&id=a9be0534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9be0534",
  null
  
)

export default component.exports